var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useReducer } from 'react';
function useTable(args) {
    var _a, _b;
    var rawData = args.data, _c = args.config, config = _c === void 0 ? {} : _c;
    var _d = useReducer(function (state, payload) {
        var _a;
        var index = payload.index, forceToggle = payload.forceToggle;
        var currentRowState = state[index];
        return __assign(__assign({}, state), (_a = {}, _a[index] = forceToggle !== null && forceToggle !== void 0 ? forceToggle : !currentRowState, _a));
    }, {}), collapsedRows = _d[0], dispatchCollapsedRows = _d[1];
    var toggleRowExpand = function (rowIndex) {
        if (rowIndex === 'all') {
            var allRowsAreOpen = Object.values(collapsedRows).every(function (row) { return row; });
            for (var i = 0; i < rawData.length; i++) {
                dispatchCollapsedRows({ index: i, forceToggle: !allRowsAreOpen });
            }
            return;
        }
        dispatchCollapsedRows({ index: rowIndex });
    };
    var headerNames = Object.keys((_a = rawData[0]) !== null && _a !== void 0 ? _a : {});
    var columns = (_b = config.columns) !== null && _b !== void 0 ? _b : {};
    /* Header Formatting */
    if (columns === null || columns === void 0 ? void 0 : columns.order)
        headerNames = columns.order;
    var columnsConfig = headerNames
        .map(function (header) {
        var key = header;
        var configRow = columns === null || columns === void 0 ? void 0 : columns[header];
        if (!configRow) {
            return {
                key: key,
                hideColumn: false,
                label: key,
                align: 'left',
                width: 'auto',
                tooltip: undefined
            };
        }
        var _a = configRow.hideColumn, hideColumn = _a === void 0 ? false : _a, _b = configRow.hideLabel, hideLabel = _b === void 0 ? false : _b, _c = configRow.label, label = _c === void 0 ? key : _c, _d = configRow.align, align = _d === void 0 ? 'left' : _d, _e = configRow.width, width = _e === void 0 ? 'auto' : _e, tooltip = configRow.tooltip;
        return {
            key: key,
            hideColumn: hideColumn,
            label: hideLabel ? '' : label,
            align: align,
            width: width,
            tooltip: tooltip
        };
    })
        // let's hide columns that are set to be hidden
        .filter(function (header) { return !header.hideColumn; });
    /* End Header Formatting */
    /* Body Formatting */
    var data = rawData.map(function (rawDataRow) { var _a, _b; return (_b = (_a = config.formatter) === null || _a === void 0 ? void 0 : _a.call(config, rawDataRow)) !== null && _b !== void 0 ? _b : rawDataRow; });
    return {
        columns: columnsConfig,
        data: data,
        collapsedRows: collapsedRows,
        toggleRowExpand: toggleRowExpand
    };
}
export default useTable;
